import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TabCacheService } from 'app/services/tab-cache.service';

@Component({
  standalone: true,
  template: '',
})
export class RedirectComponent implements OnInit {
  private router = inject(Router);
  private tabCacheService = inject(TabCacheService);

  ngOnInit() {
    const segments = this.tabCacheService.getPathSegments(this.router.url);
    if (segments.length > 0) {
      const parent = segments[0];
      const child = this.tabCacheService.getChildrenTabCache(parent);
      this.router.navigate([parent, child], {
        queryParamsHandling: 'merge',
      });
    }
  }
}
